import { ChildRule } from 'modules/journey/components/RuleBuilder';
import { RuleCriteriaValue, RuleCriteriaText } from './ExitRuleSlideOver.styled';
import { RuleTypeEnum } from './ExitRuleSliderOver.constants';

const PropertyMetCriteria = ({ property }: { property?: string }) => (
  <RuleCriteriaText key={`rule-criteria-${property}`}>
    User property <RuleCriteriaValue>{property}</RuleCriteriaValue>
  </RuleCriteriaText>
);
const ConversionMetCriteria = ({ conversion }: { conversion?: string }) => (
  <RuleCriteriaText key={`rule-criteria-${conversion}`}>
    Users removed when they converted on <RuleCriteriaValue>{conversion}</RuleCriteriaValue>
  </RuleCriteriaText>
);

const EventOccursCriteria = ({ event }: { event?: string }) => (
  <RuleCriteriaText key={`rule-criteria-${event}`}>
    Event <RuleCriteriaValue>{event}</RuleCriteriaValue> occurs
  </RuleCriteriaText>
);

export const ExitRuleCriteria = ({ childRule }: { childRule: ChildRule }) => {
  const { ruleType, userField, eventName } = childRule;
  switch (ruleType) {
    case RuleTypeEnum.UserPropertyRule:
      return <PropertyMetCriteria property={userField} />;
    case RuleTypeEnum.ConversionMetExitRule:
      return <ConversionMetCriteria conversion={eventName} />;
    default:
      return <EventOccursCriteria event={eventName} />;
  }
};
